<template>
  <FieldWrapper
    :label="label"
    :state="state"
    :configs="configs"
  >
    <div class="column full-width">
      <div class="col">
        <q-input
          v-if="isMaskedValue"
          :value="value"
          dense
          outlined
          :placeholder="placeholder"
          bg-color="white"
          readonly
          class="no-select"
        />
        <q-input
          v-else
          ref="inputRef"
          :value="formattedValue"
          dense
          outlined
          :placeholder="placeholder"
          bg-color="white"
          :readonly="disabled"
        />
      </div>
    </div>
  </FieldWrapper>
</template>

<script>
import FieldWrapper from './FieldWrapper'
import { useCurrencyInput } from 'vue-currency-input'
import { watch, computed } from 'vue'

export default {
  components: {
    FieldWrapper
  },

  props: {
    value: {},
    state: {},
    label: {},
    configs: {},

    disabled: {
      type: Boolean,
      default: false
    }
  },

  setup (props) {
    const precision = Number(props.configs?.precision || 2)

    const isMaskedValue = computed(() => {
      return typeof props.value === 'string' && props.value.includes('*')
    })

    const {
      inputRef,
      formattedValue,
      setValue
    } = useCurrencyInput({
      locale: 'de-DE',
      currency: 'BRL',
      precision,
      modelValue: props.value,
      useGrouping: true,
      currencyDisplay: 'hidden',
      exportValueAsInteger: false,
      hideCurrencySymbolOnFocus: false,
      hideGroupingSeparatorOnFocus: false,
      hideNegligibleDecimalDigitsOnFocus: false
    })

    watch(
      () => props.value,
      (value) => {
        if (!isMaskedValue.value) {
          setValue(value)
        }
      }
    )

    return {
      inputRef,
      precision,
      formattedValue,
      isMaskedValue
    }
  },

  computed: {
    placeholder () {
      return this.configs?.placeholder
    }
  }
}

</script>

<style lang="sass" scoped>
.no-select
  user-select: none
  -webkit-user-select: none
</style>
